import React, { useEffect } from "react";
import themePropTypes from "../theme-prop-types";
import { updateTimePickerOptionsAndValues } from "../../utils/time-picker-builder";

const BasicTimePicker = ({
  min_hour,
  max_hour,
  delaySchedule,
  value,
  title,
  onChange,
  components,
  settings,
  params,
  time_zone
}) => {
  const { Label, Select, Radio } = components;
  const [options, values] = updateTimePickerOptionsAndValues(
    min_hour,
    max_hour,
    delaySchedule,
    time_zone,
    value,
    settings,
    params
  );
  useEffect(() => onChange(values), [value.type]);
  return (
    <div className='basic-time-picker-web-sdk' data-testid='basic-time-picker'>
      {title ? (
        <Label text={title} name='type' />
      ) : (
        <Label text={settings.translations.type} name='type' />
      )}
      <Select
        options={options.type.map(({ value: valueItem, text }) => ({
          value: valueItem,
          label: text
        }))}
        selectedOption={values.type}
        onChange={type => onChange({ ...values, type })}
        name='type'
      />
      {values.type !== "OND" && (
        <div className='basic-time-picker-conditionals-web-sdk'>
          <div className='basic-time-picker-conditional-web-sdk'>
            <Label text={settings.translations.hour} name='hour' />
            <Select
              options={options.hour.map(option => ({
                value: option,
                label: option
              }))}
              selectedOption={values.hour}
              onChange={hour => onChange({ ...values, hour })}
              name='hour'
            />
          </div>
          <div className='basic-time-picker-conditional-web-sdk'>
            <Label text={settings.translations.minutes} name='minutes' />
            <Select
              options={options.minute.map(option => ({
                value: option,
                label: option === 0 ? `0${option}` : option
              }))}
              selectedOption={values.minute}
              onChange={minute => onChange({ ...values, minute })}
              name='minutes'
            />
          </div>
          <div className='basic-time-picker-conditional-web-sdk'>
            <Radio
              label='AM'
              name='am'
              disabled={!options?.ampm.includes("am")}
              checked={values.ampm === "am"}
              onChange={() => onChange({ ...values, ampm: "am" })}
            />
            <Radio
              label='PM'
              name='pm'
              disabled={!options?.ampm.includes("pm")}
              checked={values.ampm === "pm"}
              onChange={() => onChange({ ...values, ampm: "pm" })}
            />
          </div>
        </div>
      )}
    </div>
  );
};

BasicTimePicker.propTypes = themePropTypes.basicTimePicker;

export default BasicTimePicker;
